import { EXTERNAL_LINKS } from '../../utils/constants/routes';

// Shared "terms" link used in the outreach message popups. Points at the
// td-website terms page (see EXTERNAL_LINKS) and opens in a new tab.
const TermsLink = () => (
  <a
    href={EXTERNAL_LINKS.TERMS_N_CONDITIONS}
    target="_blank"
    rel="noopener noreferrer"
    className="terms-link"
  >
    terms
  </a>
);

export default TermsLink;
